exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pdf-reader__mobile-container{height:100%;width:100%}", ""]);
